import { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';

import { history } from '../App/history';
import Routes from './routes';

export default () => {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(
    () =>
      history.listen((update) => {
        if (update.action === "PUSH") {
          const targetPath = update.location.pathname;

          setPath(targetPath);
        }
      }),
    []
  );

  return (
    <Router location={path} navigator={history}>
      <Routes />
    </Router>
  );
};
